import { useContext, useRef, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import AvatarDefault from "../assets/img/avatars/01.jpg";
import { AuthContext } from "../context/AuthContext";
import { uploadUserImage } from "../_services/userService";
import { ToastContext } from "../context/ToastContext";

const AccountLayout = ({ children }) => {
  const { userInfo,updateAvatar,updateUserInformation } = useContext(AuthContext);
  const [avatar, setAvatar] = useState(AvatarDefault); // Current avatar
  const [preview, setPreview] = useState(null); // Preview selected
  const [editing, setEditing] = useState(false); // Show OK/Cancel
  const [avatarFile, setAvatarFile] = useState(null); // <== store file object
  const fileInputRef = useRef();
  const { showToast } = useContext(ToastContext);
  
  

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAvatarFile(file); // <== keep the File object for upload
    const reader = new FileReader();
    reader.onload = () => {
      setPreview(reader.result); // Base64 preview
      setEditing(true);
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    if (!avatarFile) 
      return;
    try {
      await uploadUserImage(avatarFile);
      setAvatar(preview);
      setPreview(null);
      setEditing(false);
      updateAvatar(preview);
    }
    catch (err) {
      showToast("Failed to upload the image.", "danger");
     
    }
  };

  const handleCancel = () => {
    setPreview(null);
    setEditing(false);
  };

  return (
    <section className="">
      <div className="container pt-5 mt-4 mt-lg- mt-xl-5">
        <div className="row pt-sm-2 pt-lg-0"  style={{ marginLeft: "-50px"  }}>
          <aside className="col-lg-3" style={{ marginTop: "-75px"  }}>
            <div
              className="offcanvas-lg offcanvas-start sticky-lg-top pe-lg-3 pe-xl-4"
              id="accountSidebar"
            >
              <div className="d-none d-lg-block" style={{ height: "105px" }}></div>

              {/* Header */}
              <div className="offcanvas-header d-lg-block py-3 p-lg-0">
                <div className="d-flex flex-row flex-lg-column align-items-center align-items-lg-start">
                  <div className="position-relative">
                    <div
                      className="flex-shrink-0 bg-body-secondary border rounded-circle overflow-hidden"
                      style={{ width: "64px", height: "64px", position: "relative" }}
                    >
                      <img
                        src={userInfo?.image_url || avatar}
                        alt="Avatar"
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      <button
                        className="btn btn-light btn-sm d-flex align-items-center justify-content-center p-0 position-absolute"
                        title="Edit Avatar"
                        onClick={handleEditClick}
                        style={{
                          width: "24px",
                          height: "24px",
                          bottom: "0",
                          right: "0",
                          borderRadius: "50%",
                          border: "1px solid #ccc",
                          zIndex: 10,
                        }}
                      >
                        <i className="fi-edit fs-xs"></i>
                      </button>
                    </div>

                    {editing && (
                      <div className="mt-2 d-flex justify-content-end">
                        <button
                          className="btn btn-success btn-sm me-2 rounded-circle"
                          onClick={handleSave}
                          style={{ width: "30px", height: "30px", padding: "0" }}
                        >
                          <i className="fi-check"></i>
                        </button>
                        <button
                          className="btn btn-danger btn-sm rounded-circle"
                          onClick={handleCancel}
                          style={{ width: "30px", height: "30px", padding: "0" }}
                        >
                          <i className="fi-x"></i>
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="pt-lg-3 ps-3 ps-lg-0">
                    <h6 className="mb-1">{userInfo?.name || ""}</h6>
                    <p className="fs-sm mb-0">{userInfo?.email || ""}</p>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn-close d-lg-none"
                  data-bs-dismiss="offcanvas"
                  data-bs-target="#accountSidebar"
                  aria-label="Close"
                ></button>
              </div>

              {/* Sidebar nav */}
              <div className="offcanvas-body d-block pt-2 pt-lg-4 pb-lg-0 mb-5">
                <nav className="list-group list-group-borderless">
                  <NavLink
                    to="/account/profile"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                  >
                    <i className="fi-user fs-base opacity-75 me-2"></i>
                    My Profile
                  </NavLink>
                  <NavLink
                    to="/account/my-listing"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                  >
                    <i className="fi-layers fs-base opacity-75 me-2"></i>
                    My listings
                  </NavLink>
                  <NavLink
                    to="/account/favorites"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                  >
                    <i className="fi-heart fs-base opacity-75 me-2"></i>
                    My Favorites
                  </NavLink>
                </nav>
              </div>
            </div>
          </aside>

          <div className="col-lg-9">
            <Outlet />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccountLayout;
